import { apiSlice } from '../../store/api/apiSlice';

export const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET /api/DBoardBirthInfo
    getDashboardBirthday: builder.query<any, { schoolId: number }>({
      query: ({ schoolId }) => ({
        url: `DBoardBirthInfo`,
        method: 'GET',
        params: { School_id: schoolId },
        service: 'djangoEmis',
      }),
    }),

    // GET /api/GetAllBeoCeoDeoGetList
    getInbox: builder.query<
      any,
      {
        districtId: string;
        blockId: string;
        schoolTypeId: number;
        manageId: string;
        cateId: string;
      }
    >({
      query: ({ districtId, blockId, schoolTypeId, manageId, cateId }) => ({
        url: `GetAllBeoCeoDeoGetList`,
        method: 'GET',
        params: {
          DistId: districtId,
          BlkId: blockId,
          SchlTypeId: schoolTypeId,
          ManageId: manageId,
          CateId: cateId,
        },
        service: 'djangoEmis',
      }),
    }),

    // POST /api/GetDetailsForInboxCud  (mark mail as viewed)
    clickResponse: builder.mutation<any, { records: Record<string, any> }>({
      query: (data) => ({
        url: `GetDetailsForInboxCud`,
        method: 'POST',
        body: data,
        service: 'djangoEmis',
      }),
    }),

    // POST /api/InboxTaskCmpltPost  (save task completion response)
    saveResponse: builder.mutation<any, { records: Record<string, any> }>({
      query: (data) => ({
        url: `InboxTaskCmpltPost`,
        method: 'POST',
        body: data,
        service: 'djangoEmis',
      }),
    }),

    // GET /api/RTESeatsStuGet
    getRteSeats: builder.query<any, { schoolId: number }>({
      query: ({ schoolId }) => ({
        url: `RTESeatsStuGet`,
        method: 'GET',
        params: { SchlId: schoolId, RTE_Sch: 'Yes', Ac_Yr: '2026' },
        service: 'djangoEmis',
      }),
    }),

    // GET /api/MovieScrnAdminget
    getMovieScreening: builder.query<any, void>({
      query: () => ({
        url: `MovieScrnAdminget`,
        method: 'GET',
        service: 'djangoEmis',
      }),
    }),

    // POST /api/MovieScreenLog
    addMovieScreeningLog: builder.mutation<
      any,
      { records: Record<string, any> }
    >({
      query: (data) => ({
        url: `MovieScreenLog`,
        method: 'POST',
        body: data,
        service: 'djangoEmis',
      }),
    }),

    getUploadedFiles: builder.query<
      any,
      { bucket_name: string; file_name: string; expiry: number }
    >({
      query: ({ bucket_name, file_name, expiry }) => ({
        url: '',
        method: 'GET',
        params: { bcktId: bucket_name, filename: file_name, expiry: expiry },
        service: 'readingFileApi',
      }),
    }),
  }),
});

export const {
  useGetDashboardBirthdayQuery,
  useGetInboxQuery,
  useClickResponseMutation,
  useSaveResponseMutation,
  useGetRteSeatsQuery,
  useGetMovieScreeningQuery,
  useAddMovieScreeningLogMutation,
  useLazyGetUploadedFilesQuery,
} = dashboardApi;
